import Message from "../../message";
import EventBus from "@/services/eventBus";

export default class BoutInviteDeclined extends Message
{
    handle()
    {
        EventBus.emit('match-invite-declined', this.message);
    }
}
